<template>
  <div class="payCode">
    <div class="box">
      <p class="title">请扫描下方二维码支付</p>
      <p class="money">￥{{orderInfo.payFee}}</p>
      <div id="qrcode"></div>
      <img class="icon" src="../../assets/images/courier/close.png" alt="" @click="close">
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'  // 引入qrcode
import {mapState} from 'vuex'
export default {
  mounted() {
    this.qrcode()
  },
  methods: {
    close() {
      this.$emit('closeCode')
    },
    // 生成二维码
    qrcode(){
      let url = ''
      if(typeof this.balancePay === 'string') {
        url = this.balancePay
      }else {
        url = this.balancePay.code_url
      }
      let qrcode = new QRCode('qrcode', {
        text: url,
        width: 313,
        height: 313,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    }
  },
  computed: {
    ...mapState(['balancePay', 'orderInfo'])
  }
}
</script>

<style scoped lang="less" type="text/less">
.payCode{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.5);
  z-index: 1000;
  .box {
    position: relative;
    width: 410px;
    margin: 50px auto;
    padding: 50px 30px 25px;
    background: #fff;
    border-radius: 10px;
    box-sizing: border-box;
    .title{
      margin-bottom: 43px;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      color: #2c2c2c;
    }
    .money{
      color:#E60012;
      font-size:20px;
      text-align: center;
    }
    #qrcode{
      display: block;
      width: 313px;
      height: 313px;
      margin:36px auto 20px;
      background: #eee;
    }
    .icon{
      position: absolute;
      top: 13px;
      right: 16px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pay/PayCode.vue